import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

/**
 * Dedicated Supabase client for the admin portal.
 * Uses a separate localStorage key ('paynovus-admin-auth') so that
 * admin sessions are completely isolated from customer/BaaS/PM sessions,
 * preventing cross-portal auth interference via onAuthStateChange.
 */
export const adminSupabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storageKey: 'paynovus-admin-auth',
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});

/**
 * Alias so admin pages can import { supabase } from '@/integrations/supabase/adminClient'
 * and get the admin-session-aware client without changing their usage pattern.
 */
export const supabase = adminSupabase;
